// services/common/axiosInstance.ts
import axios from "axios";
import appConfig from "config";

import config from "config";

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const axiosInstanceAuth = axios.create({
  baseURL: config.api.API_URL,
  withCredentials: true,
});







// ✅ Use request interceptor to attach all headers
axiosInstanceAuth.interceptors.request.use(
  (config) => {
    const authUser = sessionStorage.getItem("authUser");
    const token = authUser ? JSON.parse(authUser).access_token : null;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["client-id"] = appConfig.app.CLIENT_ID;

    config.headers["Content-Type"] = "application/json";



    return config;
  },
  (error) => Promise.reject(error)
);











// ✅ Response interceptor to refresh token on 401
axiosInstanceAuth.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          return axiosInstanceAuth(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshResponse = await axios.post(
          config.api.API_URL + "/auth/refresh-token",
          {},
          { withCredentials: true }
        );

        const newAccessToken = refreshResponse.data.access_token;

        const authUser = sessionStorage.getItem("authUser");
        if (authUser) {
          const parsed = JSON.parse(authUser);
          parsed.access_token = newAccessToken;
          sessionStorage.setItem("authUser", JSON.stringify(parsed));
        }

        axiosInstanceAuth.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
        processQueue(null, newAccessToken);

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstanceAuth(originalRequest);
      } catch (err) {
        processQueue(err, null);
        sessionStorage.removeItem("authUser");
        window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstanceAuth;




